// -- Endpoints --

// test form
export const TEST_ADD = '/api/online-test';
export const TEST_EDIT = '/api/online-test';
export const TEST_GET_TYPES = '/api/online-test/types';
export const TEST_GET_TEST_INFO = '/api/online-test';

export default TEST_ADD;
